class Api {
  static actionTypeEnum = {
    read: "read",
    update: "update",
  };

  levelId = {};
  isStandAlone = null;
  baseUrl = "";

  constructor(auth, siteId) {
    this.levelId = { realm: auth.realm?.id, org: auth.orgs?.id, site: siteId ?? auth.sites?.id };
    this.isStandAlone = this._checkStandAlone();
    this.baseUrl = this._getBaseUrl();

    Api.instance = this;
  }

  static init = (auth, siteId) => {
    Api.instance = null;
    return new Api(auth, siteId);
  }

  _checkStandAlone = () => {
    return !this.levelId.org || Object.keys(this.levelId.org).length === 0;
  }

  _getBaseUrl = () => {
    return this.isStandAlone ? `/orgs/:orgId/sites/:siteId` : `/ents/:entId/orgs/:orgId/sites/:siteId`;
  }

  _getParams = clientId => {
    return this.isStandAlone ? { orgId: this.levelId.realm, siteId: this.levelId.site, clientId } : { entId: this.levelId.realm, orgId: this.levelId.org, siteId: this.levelId.site, clientId };
  }

  getSelectedClientRequestParams = clientId => {
    const url = `${this.baseUrl}/clients/:clientId/status`;
    const apiKey = `${url}.${Api.actionTypeEnum.read}`;
    const params = this._getParams(clientId);

    return {
      apiKey,
      params,
    };
  }

  getUpdateRequestParams = clientId => {
    const url = `${this.baseUrl}/clients/:clientId/settings`;
    const apiKey = `${url}.${Api.actionTypeEnum.update}`;
    const params = this._getParams(clientId);

    return {
      apiKey,
      params,
    };
  }

  getStatisticsRequestParams = clientId => {
    const url = `${this.baseUrl}/clients/:clientId/stats`;
    const apiKey = `${url}.${Api.actionTypeEnum.read}`;
    const params = this._getParams(clientId);

    return {
      apiKey,
      params,
    };
  }
}

export default Api;